import axios from '@/api/libs/api.request'

/**
 * 登录
 * @param {User{
 * "email":"",
 * "password":""
 * }}
 * data
 * @returns
 */
export const login = data => {
  return axios.request({
    url: '/user/login',
    method: 'post',
    data: data
  })
}

/**
 * 修改密码
 * @param {body{
 * "email":"",
 * "password":""
 * }} data
 * @returns
 */
export const updatePassword = data => {
  return axios.request({
    url: '/user/updatePassword',
    method: 'post',
    data: data
  })
}

/**
 * 注册
 * @param {User{
 * "type":"",
 * "email":"",
 * "name":"",
 * "country":"",
 * "password":"",
 * "unit":""
 * }} data
 * @returns
 */
export const register = data => {
  return axios.request({
    url: '/user/register',
    method: 'post',
    data: data
  })
}

/**
 * 角色list
 * @param {body{
 * "type":""
 * }} data
 * @returns
 */
export const roleList = data => {
  return axios.request({
    url: '/user/roleList',
    method: 'post',
    data: data
  })
}

/** **暂存作者信息 */
export const tsAuthorInfo = data => {
  return axios.request({
    url: '/manuscripts/tsAuthorInfo',
    method: 'post',
    data: data
  })
}
/** **获取暂存的作者信息 */
export const getTsAuthorInfo = data => {
  return axios.request({
    url: '/manuscripts/getTsAuthorInfo',
    method: 'post',
    data: data
  })
}

/** **暂存稿件信息 */
export const tsManuscriptInfo = data => {
  return axios.request({
    url: '/manuscripts/tsManuscriptInfo',
    method: 'post',
    data: data
  })
}

/** **获取暂存的稿件信息 */
export const getTsManuscriptInfo = data => {
  return axios.request({
    url: '/manuscripts/getTsManuscriptInfo',
    method: 'post',
    data: data
  })
}

/** **暂存文件信息 */
export const tsFileInfo = data => {
  return axios.request({
    url: '/manuscripts/tsFileInfo',
    method: 'post',
    data: data
  })
}

/** **获取暂存的文件信息 */
export const getTsFileInfo = data => {
  return axios.request({
    url: '/manuscripts/getTsFileInfo',
    method: 'post',
    data: data
  })
}

/** **暂存推荐、回避审稿人信息 */
export const tsReviewersInfo = data => {
  return axios.request({
    url: '/manuscripts/tsReviewersInfo',
    method: 'post',
    data: data
  })
}

/** **获取暂存推荐、回避审稿人的信息 */
export const getTsReviewersInfo = data => {
  return axios.request({
    url: '/manuscripts/getTsReviewersInfo',
    method: 'post',
    data: data
  })
}

/** **上传稿件接口 */

export const addManuscripts = data => {
  return axios.request({
    url: '/manuscripts/addManuscripts',
    method: 'post',
    data: data
  })
}

/**
 * 我的稿件
 * 在contributor的manuscriptList里面用到
 */
export const findManuscriptByContributorEmail = data => {
  return axios.request({
    url: '/contributor-manuscript/findManuscriptByContributorEmail',
    method: 'post',
    data: data
  })
}

/**
 * 获取修改后同一条审核
 * 在contributor的manuscriptDetail里面用到
 * @param {body{
 *
 * "manuscriptFlag":"",
 * "chargeEmail":""
 * }} data
 * @returns
 */
export const getManuscriptsChargeInfo = data => {
  return axios.request({
    url: '/editor-of-charge-manuscript/getManuscriptsChargeInfo',
    method: 'post',
    data: data
  })
}

/**
 * 责任编辑的稿件列表
 * 在editor的manuscriptList里面用到
 * @param {* chargeEmail
 * current
 * size} data
 * @returns
 */
export const findManuscriptByChargeEmail = data => {
  return axios.request({
    url: '/editor-of-charge-manuscript/findManuscriptByChargeEmail',
    method: 'post',
    data: data
  })
}

/**
 * 单一审核人所有审核稿件list
 * @param {*} data
 * @returns
 */
export const findManuscriptByReviewerEmail = data => {
  return axios.request({
    url: '/reviewer-manuscript/findManuscriptByReviewerEmail',
    method: 'post',
    data: data
  })
}

/**
 * 获取修改后同一条审核
 * @param {body{
 *
 * "manuscriptFlag":"",
 * "reviewerEmail":""
 * }} data
 * @returns
 */
export const getManuscriptsReviewerInfo = data => {
  return axios.request({
    url: '/reviewer-manuscript/getManuscriptsReviewerInfo',
    method: 'post',
    data: data
  })
}

/** reviewer-manuscript */
/**
 * 审核人审稿
 * @param {*} data
 * @returns
 */
export const reviewerAddAuditOpinion = data => {
  return axios.request({
    url: '/reviewer-manuscript/addAuditOpinion',
    method: 'post',
    data: data
  })
}

/**
 * 责任编辑审核＋转发稿件
 * @param {
 * body{
 * }} data
 * @returns
 */
export const forwardManuscript = data => {
  return axios.request({
    url: '/editor-of-charge-manuscript/forwardManuscript',
    method: 'post',
    data: data
  })
}

export const viewCountShow = () => {
  return axios.request({
    url: '/view-statistics/show',
    method: 'post'
  })
}

/**
 * 文件上传
 * @param {*} data
 * @returns
 */
export const upload = data => {
  return axios.request({
    url: '/file/upload',
    method: 'post',
    data: data
  })
}

/***
 * 编辑老师二次提交
 */
export const finalSubmit = data => {
  return axios.request({
    url: '/editor-of-charge-manuscript/finalSubmit',
    method: 'post',
    data: data
  })
}

/** 专家撤销审核 */
export const reviewerCancelTheAudit = data => {
  return axios.request({
    url: '/reviewer-manuscript/reviewerCancelTheAudit',
    method: 'post',
    data: data
  })
}

/** 投稿人撤销投递 */
export const cancelTheDelivery = data => {
  return axios.request({
    url: '/contributor-manuscript/cancelTheDelivery',
    method: 'post',
    data: data
  })
}

/** 编辑撤销审核 */
export const editorCancelTheAudit = data => {
  return axios.request({
    url: '/editor-of-charge-manuscript/editorCancelTheAudit',
    method: 'post',
    data: data
  })
}

/** 编辑撤销审核 */
export const fuzzySearch = data => {
  return axios.request({
    url: '/manuscripts/fuzzySearch',
    method: 'post',
    data: data
  })
}
/** **浏览量增加 */
export const addViewCount = () => {
  return axios.request({
    url: '/view-statistics/add',
    method: 'post'
  })
}
/** **下载文件次数 */
export const getDownloadCount = () => {
  return axios.request({
    url: '/file/num',
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/data.js